import { TShopState } from '@/redux/reducers/shop';
import { TGetBranchesByShopSuccess } from '@/redux/actions/shop';

export const getBranchesByShopUpdateState = (state: TShopState, action: TGetBranchesByShopSuccess): TShopState => ({
  ...state,
  getBranchesByShopResponse: action.payload.response,
});
